import { utils, writeFile } from 'xlsx';

function exportToExcel(
  sheets: { sheetName: string; data: any[][] }[],
  filename: string = 'export.xlsx',
) {
  const workbook = utils.book_new();

  sheets.forEach(({ sheetName, data }) => {
    const worksheet = utils.aoa_to_sheet(data);
    utils.book_append_sheet(workbook, worksheet, sheetName);
  });

  writeFile(workbook, filename);
}

export function exportToCsv(
  data: unknown[][],
  filename: string = 'export.csv',
) {
  const worksheet = utils.aoa_to_sheet(data);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  writeFile(workbook, filename, { bookType: 'csv' });
}

export default exportToExcel;
